import { render, staticRenderFns } from "./ElderlyClass.vue?vue&type=template&id=0b86d3a4&scoped=true&"
import script from "./ElderlyClass.vue?vue&type=script&lang=js&"
export * from "./ElderlyClass.vue?vue&type=script&lang=js&"
import style0 from "./ElderlyClass.vue?vue&type=style&index=0&id=0b86d3a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b86d3a4",
  null
  
)

export default component.exports